import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const delCategory = createAsyncThunk('delCategory', async (data) => {

    try {
        const res = await axios({

            method: 'DELETE',
            url: process.env.REACT_APP_API_URL + `main_category/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

